module.exports = __webpack_public_path__ + "static/media/integral_card_1.58b0a110.png";